// extracted by mini-css-extract-plugin
module.exports = {"pageStructure":"PageContent_pageStructure__3FYlZ","solid":"PageContent_solid__32I5F","notSolid":"PageContent_notSolid__asN1Y"};